import { call, put } from "redux-saga/effects";
import { musicsConstants } from "../actions/constants/musicsConstant";
import { exceptionHandler } from "../pages/common/functions";
import MusicsService from "../services/api/musicsService";

function* musicsSave(request: any) {
	try {
		const result = yield call(MusicsService.musicsSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: musicsConstants.MusicsSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: musicsConstants.MusicsSaveFailure, payload: res.data });
		}

	} catch (error) {
		yield put({ type: musicsConstants.MusicsSaveFailure, payload: error });
	}
}

function* musicsGetDetail(request: any) {
	try {
		const result = yield call(
			MusicsService.musicsGetDetail,
			request.input.id
		);
		console.log(result);
		var res = exceptionHandler(result);

		if (res.status) {
			yield put({
				type: musicsConstants.MusicsDetailSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: musicsConstants.MusicsDetailFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: musicsConstants.MusicsDetailFailure,
			payload: e,
		});
	}
}

function* musicsGetByfilter(request: any) {
	try {
		const result = yield call(MusicsService.musicsGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: musicsConstants.MusicsGetByfilterSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: musicsConstants.MusicsGetByfilterFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: musicsConstants.MusicsGetByfilterFailure,
			payload: e,
		});
	}
}

function* musicsDelete(request: any) {
	try {
		const result = yield call(MusicsService.musicsDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: musicsConstants.MusicsDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: musicsConstants.MusicsDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: musicsConstants.MusicsDeleteFailure,
			payload: error,
		});
	}
}

function* musicsVideoStatusUpdate(input: any) {
	try {
		const result = yield call(MusicsService.musicsVideoStatusUpdate, input.input);
		const res = exceptionHandler(result)
		if (res.status) {
			yield put({ type: musicsConstants.MusicsVideoStatusUpdateSuccess, payload: res.data });
		}
		else {
			yield put({ type: musicsConstants.MusicsVideoStatusUpdateFailure, payload: res.data });
		}
	}
	catch (e) {
		yield put({ type: musicsConstants.MusicsVideoStatusUpdateFailure, payload: e });
	}
}

export const musicsSaga = {
	musicsGetDetail,
	musicsGetByfilter,
	musicsDelete,
	musicsSave,
	musicsVideoStatusUpdate
};
